import React, {useEffect, useState} from "react";

import type {TabsProps} from "antd";
import {HeaderPage, Tabs} from "components/common";
import "./Receive.scss";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import {
  setActiveKey,
  setButtonsHeader,
  setSiderKey,
} from "redux/reducer/common";
import {setPatientRecord} from "redux/reducer/searchPatient";
import Detail from "./Detail/Detail";
import ListPatient from "./ListPatient/ListPatient";
import HistoryExamine from "./HistoryExamine/HistoryExamine";

const SearchPatient: React.FC = () => {
  const dispatch = useAppDispatch();
  const searchPatient = useAppSelector(state => state.searchPatient);

  const items: TabsProps["items"] = [
    {
      key: tabKeys.SEARCH_PATIENT.LIST_PATIENT,
      label: `Danh sách bệnh nhân`,
      children: <ListPatient />,
    },
    {
      key: tabKeys.SEARCH_PATIENT.DETAIL,
      label: `Thông tin bệnh nhân`,
      children: <Detail />,
      forceRender: true,
      disabled: searchPatient.selected ? false : true,
    },
    {
      key: tabKeys.SEARCH_PATIENT.HISTORY,
      label: `Lịch sử khám bệnh`,
      children: <HistoryExamine />,
      disabled: searchPatient.selected ? false : true,
    },

    // {
    //   key: tabKeys.RECEIVE.TAB_3,
    //   label: `Gia hạn thẻ`,
    //   children: <ExtendCard />,
    //   disabled: patientRecord.selected ? false : true,
    // },
  ];
  const onTabClick = (key, event) => {
    dispatch(setActiveKey(key));
  };
  const activeTab = useAppSelector(state => state.common.activeTab);
  useEffect(() => {
    dispatch(setActiveKey(tabKeys.SEARCH_PATIENT.LIST_PATIENT));
    // dispatch(setSiderKey("0"));
    dispatch(setButtonsHeader([]));
    dispatch(
      setPatientRecord({
        selected: false,
        record: null,
      })
    );
  }, []);

  return (
    <div className=" receive page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} onTabClick={onTabClick} />
      </div>
    </div>
  );
};
export default SearchPatient;
